// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  customer/src/pages/policies/ReturnPolicy.jsx
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { PolicyPage, Section, Para, List, InfoCard, ContactSection } from "./PolicyLayout";

export default function ReturnPolicy() {
  return (
    <PolicyPage title="Return Policy">

      <InfoCard color="yellow">
        <Para>⚠️ <strong>Important Note:</strong> Quickry is a food and grocery delivery platform. Due to the perishable nature of our products, we generally do not support physical returns. However, we ensure full resolution through refunds or replacements.</Para>
      </InfoCard>

      <Section title="1. Nature of Our Products">
        <Para>Quickry delivers food from restaurants and grocery products from local stores. Most of these items are:</Para>
        <List items={[
          "Perishable in nature (food, vegetables, dairy, meat)",
          "Prepared fresh on order (restaurant food)",
          "Not suitable for return once delivered",
        ]}/>
        <Para>Therefore, <strong>physical returns are generally not applicable</strong> for Quickry orders.</Para>
      </Section>

      <Section title="2. When Returns/Replacements Apply">
        <InfoCard color="green">
          <div style={{ fontWeight: 700, fontSize: "0.88rem", color: "#16a34a", marginBottom: 8 }}>
            ✅ You may request a return/replacement for:
          </div>
          <List items={[
            "Wrong item delivered: You received a different product than ordered",
            "Sealed grocery items: Unopened, sealed packaged grocery items that are damaged or expired",
            "Incorrect quantity: Fewer items delivered than ordered",
            "Tampered packaging: Delivery arrived with broken seal or tampered packaging",
          ]}/>
        </InfoCard>
        <InfoCard color="red">
          <div style={{ fontWeight: 700, fontSize: "0.88rem", color: "#dc2626", marginBottom: 8 }}>
            ❌ Returns/replacements are NOT applicable for:
          </div>
          <List items={[
            "Prepared/cooked food items once delivered",
            "Perishable items like fresh vegetables, fruits, dairy after delivery",
            "Items where the packaging is opened/consumed",
            "Change of mind after delivery",
            "Requests made more than 2 hours after delivery",
          ]}/>
        </InfoCard>
      </Section>

      <Section title="3. Resolution Process">
        <Para>Instead of physical returns, Quickry resolves issues through:</Para>
        <List items={[
          "Full Refund: Credited to your original payment method or Quickry wallet",
          "Partial Refund: For missing or incorrect items",
          "Re-delivery: Subject to availability and vendor approval",
        ]}/>
      </Section>

      <Section title="4. How to Report an Issue">
        <InfoCard color="orange">
          <div style={{ fontSize: "0.88rem", color: "#555", lineHeight: 1.8 }}>
            <strong>📱 Through the App:</strong><br/>
            Orders → Select Order → Report an Issue → Select problem type → Submit with photo<br/><br/>
            <strong>⏰ Time limit:</strong> Report within <strong>2 hours</strong> for food items, <strong>24 hours</strong> for grocery/packaged items.
          </div>
        </InfoCard>
      </Section>

      <Section title="5. Evidence Required">
        <Para>To process your return/replacement request, please provide:</Para>
        <List items={[
          "Photo of the delivered item(s)",
          "Photo of the packaging (if damaged)",
          "Order ID and delivery time",
          "Clear description of the issue",
        ]}/>
      </Section>

      <Section title="6. Vendor-Specific Policies">
        <Para>For certain grocery items (non-perishable, sealed products), individual vendor return policies may apply. These will be clearly mentioned on the product listing page.</Para>
      </Section>

      <ContactSection />
    </PolicyPage>
  );
}
